import { NestedPermission } from "./PermissionsSelectField"
import {
     CONST_USER_PERMISSION_ADMINISTRATION_ASSURANCES_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_ARRETS_MALADIE_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_BL_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DDC_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DECLARATIONS_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_ARRETS_MALADIE_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DDC_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DECLARATIONS_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_ADD_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_VIEW,
     CONST_USER_PERMISSION_AI_USAGE_VIEW,
     CONST_USER_PERMISSION_ANNUAIRE_VIEW,
     CONST_USER_PERMISSION_BUSINESS_CLIENT_VIEW,
     CONST_USER_PERMISSION_BUSINESS_COLLAB_VIEW,
     CONST_USER_PERMISSION_BUSINESS_FOURNISSEUR_VIEW,
     CONST_USER_PERMISSION_BUSINESS_PTF_VIEW,
     CONST_USER_PERMISSION_BUSINESS_VIEW,
     CONST_USER_PERMISSION_DECLARATIONS_VIEW,
     CONST_USER_PERMISSION_GOOGLE_APPS_VIEW,
     CONST_USER_PERMISSION_OUTILS_COST_TOOL_VIEW,
     CONST_USER_PERMISSION_OUTILS_EXPORTS_VIEW,
     CONST_USER_PERMISSION_OUTILS_PDF_UTILS_VIEW,
     CONST_USER_PERMISSION_OUTILS_SIGNATURE_VIEW,
     CONST_USER_PERMISSION_OUTILS_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_ANNONCES_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_CANDIDATS_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_DEMANDE_EMBAUCHE_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_VIEW,
     CONST_USER_PERMISSION_RECRUTEMENT_VIVIERS_VIEW,
     CONST_USER_PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW,
     CONST_USER_PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW,
     CONST_USER_PERMISSION_RESSOURCES_VIEW,
     CONST_USER_PERMISSION_TDB_ALERTES_VIEW,
     CONST_USER_PERMISSION_TDB_INDICATEURS_VIEW,
     CONST_USER_PERMISSION_TDB_VIEW,
} from "@common-constants/*"

export const PERMISSIONS_DATA: NestedPermission[] = [
     { value: CONST_USER_PERMISSION_ANNUAIRE_VIEW, label: "Annuaire" },
     { value: CONST_USER_PERMISSION_GOOGLE_APPS_VIEW, label: "Google Apps" },
     { value: CONST_USER_PERMISSION_AI_USAGE_VIEW, label: "Usage IA" },
     { value: CONST_USER_PERMISSION_DECLARATIONS_VIEW, label: "Déclarations" },
     {
          value: CONST_USER_PERMISSION_OUTILS_VIEW,
          label: "Outils",
          children: [
               { value: CONST_USER_PERMISSION_OUTILS_COST_TOOL_VIEW, label: "Cost Tool" },
               { value: CONST_USER_PERMISSION_OUTILS_SIGNATURE_VIEW, label: "Signature" },
               { value: CONST_USER_PERMISSION_OUTILS_EXPORTS_VIEW, label: "Exports" },
               { value: CONST_USER_PERMISSION_OUTILS_PDF_UTILS_VIEW, label: "PDF Utils" },
          ],
     },
     {
          value: CONST_USER_PERMISSION_TDB_VIEW,
          label: "Tableau de bord",
          children: [
               { value: CONST_USER_PERMISSION_TDB_ALERTES_VIEW, label: "Alertes" },
               { value: CONST_USER_PERMISSION_TDB_INDICATEURS_VIEW, label: "Indicateurs" },
          ],
     },
     {
          value: CONST_USER_PERMISSION_RECRUTEMENT_VIEW,
          label: "Recrutement",
          children: [
               { value: CONST_USER_PERMISSION_RECRUTEMENT_ANNONCES_VIEW, label: "Annonces" },
               { value: CONST_USER_PERMISSION_RECRUTEMENT_CANDIDATS_VIEW, label: "Candidats" },
               { value: CONST_USER_PERMISSION_RECRUTEMENT_VIVIERS_VIEW, label: "Viviers" },
               { value: CONST_USER_PERMISSION_RECRUTEMENT_DEMANDE_EMBAUCHE_VIEW, label: "Demandes d'embauche" },
          ],
     },
     {
          value: CONST_USER_PERMISSION_BUSINESS_VIEW,
          label: "Business",
          children: [
               { value: CONST_USER_PERMISSION_BUSINESS_PTF_VIEW, label: "PTF" },
               { value: CONST_USER_PERMISSION_BUSINESS_COLLAB_VIEW, label: "Collaborateurs" },
               { value: CONST_USER_PERMISSION_BUSINESS_CLIENT_VIEW, label: "Clients" },
               { value: CONST_USER_PERMISSION_BUSINESS_FOURNISSEUR_VIEW, label: "Fournisseurs" },
          ],
     },
     {
          value: CONST_USER_PERMISSION_ADMINISTRATION_VIEW,
          label: "Administration",
          children: [
               {
                    value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_VIEW,
                    label: "Production",
                    children: [
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DECLARATIONS_VIEW, label: "Gestion Déclarations" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DDC_VIEW, label: "Gestion DDC" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_ARRETS_MALADIE_VIEW, label: "Gestion Arrêts Maladie" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_BL_VIEW, label: "Gestion BL" },
                    ],
               },
               {
                    value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_VIEW,
                    label: "Structure",
                    children: [
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW, label: "Gestion Staff (accès complet)" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED, label: "Gestion Staff (restreint — sans actions)" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER, label: "Gestion Staff (manager — ses subordonnés)" },
                         // Ajouter Staff : capacité indépendante, cumulable avec l'un des 3 niveaux d'accès ci-dessus
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_ADD_VIEW, label: "Ajouter Staff" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DECLARATIONS_VIEW, label: "Gestion Déclarations" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DDC_VIEW, label: "Gestion DDC" },
                         { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_ARRETS_MALADIE_VIEW, label: "Gestion Arrêts Maladie" },
                    ],
               },
               { value: CONST_USER_PERMISSION_ADMINISTRATION_ASSURANCES_VIEW, label: "Assurances" },
          ],
     },
     {
          value: CONST_USER_PERMISSION_RESSOURCES_VIEW,
          label: "Ressources",
          children: [
               { value: CONST_USER_PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW, label: "Bibliothèque" },
               { value: CONST_USER_PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW, label: "Documents d'embauche" },
          ],
     },
]
